import axios from "axios";

type Input = {
  name: string;
  email: string;
  personal_phone: string;
};
type Url =
  "https://api.rd.services/platform/conversions?api_key=ef5c109023707516953d6f7a1de43eeb";
type Output = {
  event_uuid: string;
};

export class UseCasePostLeadOpeningJob {
  //   constructor() {}

  public run = async (body: Input) => {
    const url: Url =
      "https://api.rd.services/platform/conversions?api_key=ef5c109023707516953d6f7a1de43eeb";

    const result = await axios.post<Input, Output>(url, {
      event_type: "CONVERSION",
      event_family: "CDP",
      payload: {
        conversion_identifier: "harpio-form-abertura-vagas-site",
        ...body,
        legal_bases: [
          { category: "communications", type: "consent", status: "granted" },
        ],
      },
    });

    return result;
  };
}
